var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
		_vm.disableQuill ? 'disableClass' : 'enableClass',
		_vm.designClass ? 'designQuill' : '', // will add only if passed
	]},[_c('quill-editor',{attrs:{"options":_vm.editorOption,"auto-focus":false,"disabled":_vm.disableQuill},model:{value:(_vm.editorContent),callback:function ($$v) {_vm.editorContent=$$v},expression:"editorContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }